import { env } from "../utils/env";

export const maximumUploadFiles = parseInt(env.REACT_APP_MAXIMUM_UPLOAD_FILES ?? "10");
export const maximumUploadSize = parseInt(
  env.REACT_APP_MAXIMUM_UPLOAD_SIZE ?? `${10 * 1024 * 1024}`,
);
